"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EditProvider = void 0;
const asset_list_1 = require("client/components/asset-list");
const asset_list_overview_1 = require("client/components/asset-list-overview");
const confirmation_modal_1 = require("client/components/confirmation-modal");
const icons_1 = require("client/components/icons");
const button_1 = require("client/components/material/button");
const checkbox_1 = require("client/components/material/checkbox/checkbox");
const date_picker_1 = require("client/components/material/date-picker/date-picker");
const menu_1 = require("client/components/material/menu");
const select_1 = require("client/components/material/select");
const text_area_1 = require("client/components/material/text-area");
const text_field_1 = require("client/components/material/text-field");
const modal_1 = require("client/components/modal");
const ui_1 = require("client/components/ui");
const callable_1 = require("client/components/ui/callable");
const multi_select_1 = require("client/components/ui/multi-select");
const text_button_1 = require("client/components/ui/text-button");
const store_1 = require("client/modules/app-settings/store");
const iframe_preview_1 = require("client/modules/inventory-order/tabs/order-review/components/iframe-preview");
const store_2 = require("client/modules/providers/store");
const store_3 = require("client/modules/sites/modules/sites-detail/store");
const store_4 = require("client/modules/sites/modules/sites-list/store");
const store_5 = require("client/modules/users/modules/users-list/store");
const store_6 = require("client/modules/users/store");
const material_ui_1 = require("material-ui");
const Menu_1 = require("material-ui/Menu");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const ramda_1 = require("ramda");
const React = require("react");
const react_1 = require("react");
const ReactTooltip = require("react-tooltip");
const app_settings_1 = require("shared/app-settings");
const permissions_1 = require("shared/permissions");
const throttle_debounce_1 = require("throttle-debounce");
require("./edit-provider.less");
const moment = require("moment");
const dummyProvider = {
    email: "",
    firstName: "",
    lastName: "",
    id: 0,
    phone: "",
    phoneExt: "",
    dea: "",
    deaExp: null,
    notes: "",
    npiNumber: "",
    state: "",
    stateLicense: "",
    stateLicenseExp: new Date(),
    title: ""
};
const statesStr = [
    "AK",
    "AL",
    "AR",
    "AZ",
    "CA",
    "CO",
    "CT",
    "DC",
    "DE",
    "FL",
    "GA",
    "HI",
    "ID",
    "IL",
    "IN",
    "IA",
    "KS",
    "KY",
    "LA",
    "ME",
    "MD",
    "MA",
    "MI",
    "MN",
    "MS",
    "MO",
    "MT",
    "NE",
    "NV",
    "NH",
    "NJ",
    "NM",
    "NY",
    "NC",
    "ND",
    "OH",
    "OK",
    "OR",
    "PA",
    "RI",
    "SC",
    "SD",
    "TN",
    "TX",
    "UT",
    "VT",
    "VA",
    "WA",
    "WV",
    "WI",
    "WY"
];
const states = statesStr.sort().map((state, i) => ({
    id: i,
    label: state,
    value: state
}));
// const titlesStr = ["MD", "DC", "DO", "DPM", "NP", "APRN", "PA", "RN"].sort();
// const titles: IMenuItem[] = titlesStr.map((title, i) => ({
//   id: i,
//   label: title,
//   value: title
// }));
let EditProvider = class EditProvider extends react_1.Component {
    constructor() {
        super(...arguments);
        this.sitesInChargeOf = [];
        this.iframeUrl = "";
        this.assetModal = false;
        this.providerSitesAbsent = new Map();
        this.sitesAbsentChanged = false;
        this.inChargeOfChanged = false;
        this.titlesStr = [];
        this.titles = [];
        this.highLevelTitles = [];
        // public users: any[] = [];
        this.canModifyRelations = false;
        this.showConfirmationEditProviderSave = false;
        this.loadSites = throttle_debounce_1.debounce(200, (filterText) => {
            const keyword = filterText ? filterText : "";
            const options = {
                count: 100,
                search: keyword,
                start: 0,
                where: ""
            };
            store_4.sitesListStore.loadSitesNoRelation(options);
        });
        this.updateSitesInChargeOf = () => {
            const canBePic = this.highLevelTitles.includes(this.provider.title);
            this.sitesInChargeOf =
                this.provider && this.provider.sites
                    ? this.provider.sites.filter(site => canBePic && site.picProviderId === this.provider.id)
                    : [];
        };
        this.initializeProviderSiteAbsent = () => {
            const { sites, sitesAbsent } = this.provider;
            if (!sites || !sites.length) {
                return;
            }
            for (const site of sites) {
                // const flag = !canBePic || sitesAbsent.find(siteAbsent => siteAbsent.id === site.id)
                const flag = sitesAbsent.find(siteAbsent => siteAbsent.id === site.id)
                    ? true
                    : false;
                this.providerSitesAbsent.set(site.id, flag);
            }
        };
        this.injectProviderSitesAbsent = () => {
            this.provider.sitesAbsent = this.provider.sites.filter(site => {
                const providerIsUnavailableForSite = this.providerSitesAbsent.get(site.id);
                return providerIsUnavailableForSite;
            });
        };
        this.handleProviderSiteAbsent = (site) => () => {
            const currentFlag = this.providerSitesAbsent.get(site.id);
            this.providerSitesAbsent.set(site.id, !currentFlag);
            if (this.providerSitesAbsent.get(site.id)) {
                // update in charge of selection
                this.sitesInChargeOf = this.sitesInChargeOf.filter(siteInCharge => siteInCharge.id !== site.id);
            }
            if (!this.sitesAbsentChanged) {
                this.sitesAbsentChanged = true;
            }
        };
        this.renderSitesAbsent = (canEdit) => {
            const { sites } = this.provider;
            return sites
                ? sites.map((site, index) => (React.createElement(checkbox_1.MaterialCheckbox, { disabled: !canEdit, key: index, onAction: this.handleProviderSiteAbsent(site), label: site.displayName || site.name, checked: this.providerSitesAbsent.get(site.id) || false })))
                : [];
        };
        // endregion
        this.renderProviderAssetListRow = () => this.provider.uploads && this.provider.uploads.length
            ? this.provider.uploads
                .sort((a, b) => moment(a.expDate) < moment(b.expDate) ? 1 : -1)
                .map((upload, index) => {
                let expdate = "";
                if (upload.expDate) {
                    expdate = moment(upload.expDate).format("MM/DD/YYYY");
                }
                return (React.createElement("li", { "data-tip": `${upload.fileOriginalName} ${upload.description ? " (" + upload.description + ")" : ""}
                    `, onClick: () => {
                        this.iframeUrl = upload.filePath;
                        this.currentAssetViewing = upload;
                    }, key: index, className: "list" },
                    React.createElement("div", { className: "list-expdate__name" },
                        React.createElement("span", { className: "list-expdate__name__reviewicon" }, upload.approved ? (React.createElement(icons_1.CheckmarkIcon, { fill: "#61B329" })) : upload.rejected ? (React.createElement(icons_1.CloseIcon, { fill: "#FF0000" })) : ("")),
                        upload.description || upload.fileOriginalName),
                    React.createElement("div", { className: "list-expdate__date" }, expdate ? ` ${expdate}` : "")));
            })
            : null;
        this.isProviderInCharge = () => !!(this.provider &&
            this.provider.sites &&
            this.provider.sites.find(site => site.picProviderId === this.provider.id));
        this.handleAssetsDescriptionsSave = async (uploads) => {
            await store_2.providersStore.updateAssetsDescriptions(uploads);
            await store_2.providersStore.loadProviders();
            if (store_3.sitesDetailStore.site.value) {
                await store_3.sitesDetailStore.loadEditProviders({
                    id: store_3.sitesDetailStore.site.value.id
                });
                await store_3.sitesDetailStore.loadProviders({
                    id: store_3.sitesDetailStore.site.value.id
                });
            }
            // this.forceUpdate();
        };
        this.handlePreviewClose = () => {
            this.iframeUrl = "";
            this.currentAssetViewing = null;
        };
        // endregion
        // region Event handlers
        this.onClickPads = (event) => {
            store_2.providersStore.loadActivePads(this.provider);
            this.padsOpen = event.currentTarget;
        };
        this.onClosePads = () => {
            this.padsOpen = undefined;
        };
        this.handleSelect = (fieldName) => (value) => {
            this.provider[fieldName] = value;
            if (fieldName === "title") {
                if (!this.highLevelTitles.includes(value)) {
                    this.sitesInChargeOf = [];
                }
            }
        };
        this.handleChangeString = (fieldName) => (event, value) => {
            this.provider[fieldName] = value;
        };
        this.isChanged = () => {
            const result = ramda_1.difference(Object.entries(this.provider), Object.entries(ramda_1.merge(dummyProvider, this.props.provider)));
            if (this.props.provider &&
                this.props.provider.sites &&
                this.provider.sites) {
                const sitesComparison = ramda_1.difference(this.provider.sites.map(site => site.id), this.props.provider.sites.map(site => site.id));
                const sitesComparison2 = ramda_1.difference(this.props.provider.sites.map(site => site.id), this.provider.sites.map(site => site.id));
                if (sitesComparison.length > 0 || sitesComparison2.length > 0) {
                    return true;
                }
                if (this.provider.sitesAbsent && this.props.provider.sitesAbsent) {
                    const sitesAbsentComparison = ramda_1.difference(this.provider.sitesAbsent.map(site => site.id), this.props.provider.sitesAbsent.map(site => site.id));
                    const sitesAbsentComparison2 = ramda_1.difference(this.props.provider.sitesAbsent.map(site => site.id), this.provider.sitesAbsent.map(site => site.id));
                    if (sitesAbsentComparison.length > 0 ||
                        sitesAbsentComparison2.length > 0) {
                        return true;
                    }
                }
            }
            if (this.sitesInChargeOf.length) {
                const currentSitesInChargeOfIds = this.provider.sites
                    .filter(site => site.picProviderId === this.provider.id)
                    .map(site => site.id);
                const updatedSitesInChargeOfIds = this.sitesInChargeOf.map(site => site.id);
                const sitesInChargeOfComparison1 = ramda_1.difference(currentSitesInChargeOfIds, updatedSitesInChargeOfIds);
                const sitesInChargeOfComparison2 = ramda_1.difference(updatedSitesInChargeOfIds, currentSitesInChargeOfIds);
                if (sitesInChargeOfComparison1.length > 0 ||
                    sitesInChargeOfComparison2.length > 0) {
                    return true;
                }
            }
            return result.length > 0 || this.sitesAbsentChanged || this.inChargeOfChanged;
        };
        this.isValidProvider = (field, value) => {
            const isPic = this.isProviderInCharge();
            let isValid = false;
            switch (field) {
                case "dea": {
                    const deaRe = /^\w{2}\d{7}$/g;
                    isValid = !isPic || value.match(deaRe) ? true : false;
                    break;
                }
                case "npi": {
                    const npiRe = /^\d{10}$/g;
                    isValid = value.match(npiRe) ? true : false;
                    break;
                }
                default:
                    break;
            }
            return isValid;
        };
        this.isValid = (provider) => Boolean(provider.firstName &&
            provider.lastName &&
            provider.title &&
            provider.state &&
            provider.stateLicense &&
            provider.stateLicenseExp &&
            provider.npiNumber &&
            provider.sites &&
            provider.sites.length &&
            this.isValidProvider("dea", provider.dea) &&
            this.isValidProvider("npi", provider.npiNumber));
        this.handleSubmit = () => {
            const today = new Date();
            let formatedDates = moment(today).format('MM/DD/YYYY');
            let deaExp = moment(this.provider.deaExp).format('MM/DD/YYYY');
            if (!this.isValid(this.provider)) {
                this.missing = {
                    firstName: !this.provider.firstName,
                    lastName: !this.provider.lastName,
                    title: !this.provider.title,
                    state: !this.provider.state,
                    stateLicense: !this.provider.stateLicense,
                    stateLicenseExp: !this.provider.stateLicenseExp,
                    npiNumber: !this.provider.npiNumber ||
                        !this.isValidProvider("npi", this.provider.npiNumber),
                    dea: !this.provider.dea || !this.isValidProvider("dea", this.provider.dea),
                    deaExp: !this.provider.deaExp,
                    sites: !this.provider.sites || !this.provider.sites.length
                };
                this.showConfirmationEditProviderSave = false;
            }
            else {
                this.missing = {
                    firstName: false,
                    lastName: false,
                    title: false,
                    state: false,
                    stateLicense: false,
                    stateLicenseExp: false,
                    npiNumber: false,
                    dea: false,
                    deaExp: false,
                    sites: false
                };
                // update sites in charge of
                this.provider.sitesInChargeOf = this.sitesInChargeOf;
                // check if modal is required
                this.checkConfirmation();
                // this.injectProviderSitesAbsent();
                // callable(this.props.onSave)(this.provider);
                // this.sitesAbsentChanged = false;
                // this.showConfirmationEditProviderSave = false;
            }
        };
        this.formulateConfirmationMessage = () => {
            const willUnassignedPicSites = this.getSitesUnassignPic();
            const willOverridePicSites = this.getSitesOverridePic();
            const generateUnssignedSitesMessage = willUnassignedPicSites.map(site => `${site.displayName} <br />`);
            const generateOverrideSiteMessage = willOverridePicSites.map(site => `${site.displayName} <br />`);
            // The provider in charge will be reassigned to the current provider.
            const head = "Please confirm provider in charge update. <br /><br />";
            const body1 = `The following sites are currently supervised under another provider: 
      <br /><br />
      ${generateOverrideSiteMessage}
      <br />
      `;
            const body2 = `The following sites will not have a provider in charge: 
      <br /><br />
      ${generateUnssignedSitesMessage}
      <br />
      `;
            const tail = `Do you want to proceed with the update?`;
            let message = head;
            if (willOverridePicSites.length) {
                message = message.concat(body1);
            }
            if (willUnassignedPicSites.length) {
                message = message.concat(body2);
            }
            message = message.concat(tail);
            return message;
        };
        this.submitProvider = () => {
            this.injectProviderSitesAbsent();
            callable_1.callable(this.props.onSave)(this.provider);
            this.sitesAbsentChanged = false;
            this.showConfirmationEditProviderSave = false;
        };
        this.getSitesUnassignPic = () => {
            const currentlySitesInChargeOf = this.provider.sites.filter(site => site.picProviderId === this.provider.id);
            const sitesThatWillBeUnassigned = currentlySitesInChargeOf.filter(site => !this.sitesInChargeOf.find(inChargeOf => inChargeOf.id === site.id));
            return sitesThatWillBeUnassigned;
        };
        this.getSitesOverridePic = () => {
            const sitesThatWillBeOverriden = this.sitesInChargeOf.filter(site => site.picProviderId && site.picProviderId !== this.provider.id);
            return sitesThatWillBeOverriden;
        };
        this.checkConfirmation = () => {
            const willUnassignedPic = this.getSitesUnassignPic();
            const willOverridePic = this.getSitesOverridePic();
            const shouldAskConfirmation = willUnassignedPic.length || willOverridePic.length;
            if (shouldAskConfirmation) {
                this.showConfirmationEditProviderSave = true;
            }
            else {
                this.submitProvider();
            }
        };
        this.handleCancel = () => {
            this.props.onCancel();
        };
        this.handleChangeDeaExp = (value) => {
            // string to Date
            this.provider.deaExp = value;
        };
        this.handleClickClearDeaExp = () => {
            this.provider.deaExp = null;
        };
        this.handleChangeSLExp = (value) => {
            // string to Date
            this.provider.stateLicenseExp = value; // was set to value
        };
        this.handelDelete = () => {
            callable_1.callable(this.props.onDelete)(this.provider);
        };
        this.getMultiSelectValues = () => {
            const selectedItems = [];
            this.provider.sites &&
                this.provider.sites.map((site, i) => {
                    const item = {
                        id: site.id,
                        label: site.displayName || site.name,
                        value: String(site.id),
                        tokenLabel: site.displayName || site.name
                    };
                    selectedItems.push(item);
                });
            return selectedItems;
        };
        this.getMultiSelectValuesInChargeOf = () => {
            const selectedItems = [];
            this.sitesInChargeOf
                // .filter(site => site.picProviderId === this.provider.id)
                .map((site, i) => {
                const item = {
                    id: site.id,
                    label: site.displayName || site.name,
                    value: String(site.id),
                    tokenLabel: site.displayName || site.name
                };
                selectedItems.push(item);
            });
            return selectedItems;
        };
        this.handlePadSelect = (pad) => {
            store_2.providersStore.promptSignature(pad, this.provider);
            this.padsOpen = undefined;
            const signature = this.provider.signature;
            this.signatureInterval = window.setInterval(async () => {
                const provider = await store_2.providersStore.readProvider(this.provider.id);
                if (provider && signature !== provider.signature) {
                    store_2.providersStore.loadProviders();
                    this.provider.signature = provider.signature;
                    window.clearInterval(this.signatureInterval);
                }
            }, 2500);
        };
        this.viewProviderAssets = () => {
            this.assetModal = !this.assetModal;
        };
    }
    get availableUsers() {
        const { sites } = this.provider;
        const provSites = sites ? sites.map((site) => site.id) : [];
        return store_5.usersListStore.users.value
            .filter((user) => !user.admin &&
            provSites.some((siteId) => user.sites.find(site => site.id === siteId)))
            .map((user, i) => ({
            id: i,
            label: `${user.prefix} ${user.firstName} ${user.lastName} ${user.suffix}`,
            sites: user.sites.map((site) => site.id),
            value: user.id
        }));
    }
    get availableOptions() {
        const siteIds = this.provider.sites
            ? this.provider.sites.map(site => site.id)
            : [];
        const siteOptions = store_4.sitesListStore.sites.value
            ? store_4.sitesListStore.sites.value.filter(site => siteIds.indexOf(site.id) < 0)
            : [];
        return siteOptions.map((site, i) => ({
            id: site.id,
            label: site.displayName || site.name,
            value: String(site.id),
            tokenLabel: site.displayName || site.name
        }));
    }
    get availableOptionsInCharge() {
        const canBePic = this.highLevelTitles.includes(this.provider.title);
        const availableSiteIds = canBePic && this.provider.sites
            ? this.provider.sites.map(site => site.id)
            : [];
        const siteOptions = store_4.sitesListStore.sites.value
            ? store_4.sitesListStore.sites.value
            : [];
        const availableOptions = siteOptions
            .filter(site => !this.providerSitesAbsent.get(site.id)) // filter provider-site unavailibity
            .filter(site => availableSiteIds.includes(site.id))
            // .filter(
            //   site => !site.picProviderId || site.picProviderId === this.provider.id
            // )
            .filter(site => !this.sitesInChargeOf.find(sic => sic.id === site.id))
            .map((site, i) => ({
            id: site.id,
            label: site.displayName || site.name,
            value: String(site.id),
            tokenLabel: site.displayName || site.name
        }));
        return availableOptions;
    }
    // region React
    componentWillMount() {
        this.provider = ramda_1.merge(dummyProvider, this.props.provider);
        if (this.provider) {
            store_2.providersStore.loadActivePads(this.provider);
        }
        store_5.usersListStore.loadUsers();
        this.missing = {
            firstName: false,
            lastName: false,
            title: false,
            state: false,
            stateLicense: false,
            stateLicenseExp: false,
            npiNumber: false,
            dea: false,
            deaExp: false,
            sites: false
        };
        this.updateSitesInChargeOf();
    }
    // public filterSites = (sites: Site[]) => {
    //   if (sites && sites.length === 0) return;
    //   const provSites = sites ? sites.map((site: Site) => site.id) : [];
    //   const users = this.users.filter((user: any) =>
    //     provSites.some((siteId: number) => user.sites.includes(siteId))
    //   );
    //   return users;
    // };
    async componentDidMount() {
        const highLevelTitles = await store_1.appSettingsStore.readSettings(app_settings_1.AppOption.PicAllowedTitles, true);
        this.highLevelTitles = highLevelTitles.value.split(",");
        // this.initializeProviderSiteAbsent();
        await this.initializeData();
        const providerTitles = await store_1.appSettingsStore.readSettings(app_settings_1.AppOption.ProviderTitles, true);
        this.titlesStr = providerTitles.value.split(",").sort();
        this.titles = this.titlesStr.map((title, i) => ({
            id: i,
            label: title,
            value: title
        }));
    }
    async initializeData() {
        const user = store_6.usersStore.user.value;
        this.canModifyRelations =
            permissions_1.ROLE.isDev(user.groupId) ||
                permissions_1.ROLE.isIMBUser(user.groupId) ||
                store_6.usersStore.user.value.siteAdmin;
        // const users = usersListStore.users.value.filter(
        //   (user: User) => !user.admin
        // );
        // this.users = users.map((user: User, i) => ({
        //   id: i,
        //   label: `${user.prefix} ${user.firstName} ${user.lastName} ${user.suffix}`,
        //   sites: user.sites.map((site: Site) => site.id),
        //   value: user.id
        // }));
        this.forceUpdate();
    }
    async componentWillReceiveProps(props) {
        const highLevelTitles = await store_1.appSettingsStore.readSettings(app_settings_1.AppOption.PicAllowedTitles, true);
        this.highLevelTitles = highLevelTitles.value.split(",");
        await this.initializeData();
        if (props.provider) {
            this.provider = ramda_1.merge(dummyProvider, props.provider);
            this.initializeProviderSiteAbsent();
            this.updateSitesInChargeOf();
        }
        if (this.provider) {
            store_2.providersStore.loadActivePads(this.provider);
        }
    }
    componentWillUnmount() {
        if (this.signatureInterval) {
            window.clearInterval(this.signatureInterval);
        }
    }
    render() {
        const { slim = false } = this.props;
        const provider = this.provider || dummyProvider;
        const canEdit = store_6.usersStore.permissions.UpdateProviders;
        // C-094.1
        let DataVal;
        let isError = "";
        let errorStatus = false;
        const getNumber = provider.phone.slice(0, 14); // C-094.12 
        if (getNumber.length) {
            DataVal = getNumber.replace(/\D+/g, "")
                .replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2-$3");
            if (DataVal) {
                if (DataVal.length != 14) {
                    isError = "The information input currently is invalid";
                    errorStatus = true;
                }
                else {
                    isError = "";
                    errorStatus = false;
                }
            }
        }
        const isPic = this.isProviderInCharge();
        const canBePic = this.highLevelTitles.includes(this.provider.title);
        return (React.createElement("div", { className: "edit-provider" },
            React.createElement("a", { className: "close-button", onClick: this.handleCancel },
                React.createElement(icons_1.CloseIcon, null)),
            React.createElement("div", { className: "main" },
                React.createElement("div", { className: "main-left" },
                    React.createElement("div", { className: "provider-edit-left-side-bar" },
                        React.createElement(material_ui_1.Typography, { align: "center", variant: "title" },
                            provider.prefix,
                            " ",
                            provider.firstName,
                            " ",
                            provider.lastName,
                            " ",
                            provider.suffix),
                        React.createElement("div", { className: "view-assets-remove-provider" },
                            !this.props.newProvider &&
                                store_6.usersStore.permissions.ReadProviderAssets ? (React.createElement(asset_list_overview_1.AssetListOverview, { btnLabel: "Edit Asset", onClick: this.viewProviderAssets }, this.renderProviderAssetListRow())) : null,
                            this.props.onDelete &&
                                store_6.usersStore.permissions.DestroyProviders && (React.createElement("div", { className: "user-remove provider-edit-user-remove", style: { marginBottom: "10px" } },
                                React.createElement(icons_1.DeleteIcon, null),
                                React.createElement("div", null,
                                    React.createElement("a", { onClick: this.handelDelete, href: "#", style: { textDecoration: "none" } },
                                        React.createElement(material_ui_1.Typography, null, "REMOVE PROVIDER")))))))),
                React.createElement("div", { className: "user-info" },
                    React.createElement(ui_1.UiForm, { buttons: (canEdit || store_6.usersStore.user.value.siteAdmin) && [
                            React.createElement(button_1.MaterialButton, { className: "btnCancel", onClick: this.handleCancel }, "Cancel"),
                            "Save"
                        ], onSubmit: this.handleSubmit, loading: false, isChanged: this.isChanged, status: this.props.status ? this.props.status : ui_1.FormStatus.Clean, saved: "Saved", error: this.props.error, shouldDisableSave: errorStatus },
                        React.createElement("div", { className: "row" },
                            React.createElement("div", { className: "name" },
                                React.createElement(text_field_1.MaterialTextField, { disabled: !canEdit, autoFocus: this.props.autoFocusForm, className: "firstName", label: "Prefix", onChange: this.handleChangeString("prefix"), value: `${provider.prefix}` || "" }),
                                React.createElement(text_field_1.MaterialTextField, { disabled: !canEdit, autoFocus: this.props.autoFocusForm, className: "firstName", label: "First Name *", missing: this.missing.firstName, onChange: this.handleChangeString("firstName"), value: `${provider.firstName}` || "" }),
                                React.createElement(text_field_1.MaterialTextField, { disabled: !canEdit, className: "lastName", label: "Last Name *", missing: this.missing.lastName, onChange: this.handleChangeString("lastName"), value: `${provider.lastName}` || "" }),
                                React.createElement(text_field_1.MaterialTextField, { disabled: !canEdit, autoFocus: this.props.autoFocusForm, className: "firstName", label: "Suffix", onChange: this.handleChangeString("suffix"), value: `${provider.suffix}` || "" }))),
                        React.createElement("div", { className: "row" },
                            React.createElement(text_field_1.MaterialTextField, { disabled: !canEdit, className: "email", label: "Email", onChange: this.handleChangeString("email"), value: provider.email || "" })),
                        React.createElement("div", { className: "row phone-row" },
                            React.createElement("div", { className: "select phone" },
                                React.createElement("div", { className: "phone-ext" },
                                    React.createElement(text_field_1.MaterialTextField, { className: "phone-ext--phone", leftItem: React.createElement(icons_1.PhoneIcon, null), label: "Phone", onChange: this.handleChangeString("phone"), value: DataVal, missing: isError }),
                                    React.createElement(text_field_1.MaterialTextField, { className: "phone-ext--ext", label: "Ext", onChange: this.handleChangeString("phoneExt"), value: provider.phoneExt || "" })),
                                React.createElement("p", { style: { color: 'red' } }, isError))),
                        React.createElement("div", { className: "row" },
                            React.createElement("div", { className: "site" }, !slim && (React.createElement(multi_select_1.UiMultiSelect, { disabled: !canEdit, className: "sites", label: "Pharmacy *", missing: this.missing.sites, options: this.availableOptions, values: this.getMultiSelectValues(), onChange: values => this.onChangeMultiSelect(values), onSearch: this.loadSites })))),
                        React.createElement("div", { className: "row" },
                            React.createElement("div", { className: "absent-site" },
                                React.createElement(material_ui_1.Typography, { variant: "caption" }, "Indicate provider-site unavailibility"),
                                this.renderSitesAbsent(canEdit))),
                        React.createElement("div", { className: "row" },
                            React.createElement("div", { className: "site" },
                                !slim && canBePic && (React.createElement(multi_select_1.UiMultiSelect, { disabled: !canEdit || !canBePic, className: "sites", label: "In Charge of", options: this.availableOptionsInCharge, values: this.getMultiSelectValuesInChargeOf(), onChange: values => this.onChangeMultiSelectInChargeOf(values), onSearch: this.loadSites })),
                                !canBePic ? `*${this.provider.title} not authorized to be in charge of a pharmacy.` : null)),
                        React.createElement("div", { className: "row" },
                            React.createElement("div", { className: "deainfo" },
                                React.createElement("div", { className: "dea", "data-tip": isPic && this.missing.dea
                                        ? `DEA needs to be prefixed with 2 letters follow by 7 numeric characters`
                                        : "", "data-for": "valid-provider" },
                                    React.createElement(text_field_1.MaterialTextField, { disabled: !canEdit, className: "dea", label: "DEA", missing: isPic || !this.missing.deaExp ? this.missing.dea : false, 
                                        // required={provider.deaExp ? true : false} B-069
                                        onChange: this.handleChangeString("dea"), value: `${provider.dea}` || "" })),
                                React.createElement(select_1.MaterialSelect, { disabled: !canEdit, className: "title", label: "Title *", missing: this.missing.title, options: [...this.titles], onSelect: this.handleSelect("title"), value: provider.title || "" })),
                            React.createElement(date_picker_1.MaterialDatePicker, { disabled: !canEdit, className: "deaExp", label: "DEA Exp", missing: isPic || !this.missing.dea ? this.missing.deaExp : false, required: provider.dea ? true : false, onChange: this.handleChangeDeaExp, value: provider.deaExp || null, minDate: moment().toDate(), 
                                // B-084              //  
                                disablePast: true }),
                            React.createElement(button_1.MaterialButton, { className: "deaExp__clear-button", onClick: this.handleClickClearDeaExp }, "Clear")),
                        React.createElement("div", { className: "row" },
                            React.createElement("div", { className: "stateinfo" },
                                React.createElement(select_1.MaterialSelect, { disabled: !canEdit, className: "state", label: "State *", missing: this.missing.state, searchable: true, options: [...states], onSelect: this.handleSelect("state"), value: provider.state || "" }),
                                React.createElement(text_field_1.MaterialTextField, { disabled: !canEdit, className: "stateLic", label: "State Lic *", missing: this.missing.stateLicense, onChange: this.handleChangeString("stateLicense"), value: `${provider.stateLicense}` || "" })),
                            React.createElement(date_picker_1.MaterialDatePicker, { disabled: !canEdit, className: "stateLicExp", label: "State Lic Exp *", missing: this.missing.stateLicenseExp, onChange: this.handleChangeSLExp, minDate: moment().toDate(), 
                                // B-084             
                                disablePast: true, value: provider.stateLicenseExp })),
                        React.createElement("div", { className: "row" },
                            React.createElement("div", { className: "npiinfo", "data-tip": this.missing.npiNumber
                                    ? `NPI needs to be 10 numeric characters`
                                    : "", "data-for": "valid-provider" },
                                React.createElement(text_field_1.MaterialTextField, { disabled: !canEdit, className: "npi", label: "NPI *", missing: this.missing.npiNumber, onChange: this.handleChangeString("npiNumber"), value: `${provider.npiNumber}` || "" })),
                            React.createElement("div", { className: "npiinfo" },
                                React.createElement(select_1.MaterialSelect, { disabled: !this.canModifyRelations, className: "user", label: "User Account", missing: this.missing.title, 
                                    // options={this.filterSites(provider.sites)}
                                    options: [...this.availableUsers], 
                                    // onSelect={this.handleSelect("title")}
                                    onSelect: this.handleSelect("userId"), value: (this.provider.userId &&
                                        this.provider.userId.toString()) ||
                                        "" }))),
                        React.createElement("div", { className: "row" },
                            provider.id !== 0 && (React.createElement("div", { className: "pads" },
                                React.createElement("div", { className: "dummy-pad" },
                                    React.createElement("div", { className: "dummy-pad__label" }, "Signature"),
                                    this.provider.signature && (React.createElement("img", { src: this.provider.signature, className: "signature" })),
                                    React.createElement("div", { className: "dummy-pad__baseline" })),
                                canEdit && (React.createElement(text_button_1.UiTextButton, { secondary: true, onClick: this.onClickPads }, "Get Provider Signature")),
                                React.createElement(menu_1.MaterialMenu, { open: Boolean(this.padsOpen), onClose: this.onClosePads, anchorEl: this.padsOpen },
                                    (!store_2.providersStore.pads.value ||
                                        store_2.providersStore.pads.value.length === 0) && (React.createElement(Menu_1.MenuItem, null, "No Signature Pads Found")),
                                    store_2.providersStore.pads.value &&
                                        store_2.providersStore.pads.value.map((p, index) => (React.createElement(Menu_1.MenuItem, { key: index, onClick: () => this.handlePadSelect(p) }, p.name)))))),
                            React.createElement("div", { className: "notes-section" },
                                React.createElement(text_area_1.MaterialTextArea, { disabled: !canEdit, className: "notes", onChange: this.handleChangeString("notes"), placeholder: "Notes", value: `${provider.notes}` || "" })))))),
            this.showConfirmationEditProviderSave && (
            // <ConfirmationModal
            //   confirmText="Save"
            //   cancelText="Cancel"
            //   message={`Please confirm save. <br />Do you want to save this provider?`}
            //   onCancel={() => (this.showConfirmationEditProviderSave = false)}
            //   onConfirm={this.handleSubmit}
            //   title="Save confirmation"
            // />
            React.createElement(confirmation_modal_1.ConfirmationModal, { confirmText: "Update", cancelText: "Go back", 
                // message={`Please confirm provider in charge update. <br /><br />The selected site is currently supervised under another provider.
                // By confirming the current selection, the site's provider in charge will be reassigned to the current provider.
                // <br /><br />Do you want to proceed with the update?`}
                message: this.formulateConfirmationMessage(), onCancel: () => (this.showConfirmationEditProviderSave = false), onConfirm: this.submitProvider, title: "Update Confirmation" })),
            this.assetModal ? (React.createElement(modal_1.AssetModal, { title: `Assets For ${this.provider.prefix} ${this.provider.firstName} ${this.provider.lastName} ${this.provider.suffix}`, width: "unset", maxWidth: "55%", maxHeight: "70%", top: "100px", onCancel: () => (this.assetModal = !this.assetModal) },
                React.createElement(asset_list_1.AssetList, { uploads: provider.uploads, entityType: "provider", entityData: this.provider, onCredentialUpload: this.props.onCredentialUpload, onDeleteUpload: this.props.onDeleteUpload, onImageUpload: this.props.onImageUpload, onDescriptionSave: this.handleAssetsDescriptionsSave, onExpDateSave: this.handleAssetsDescriptionsSave, onConnectAssetSave: this.handleAssetsDescriptionsSave, onCancel: () => (this.assetModal = !this.assetModal) }))) : null,
            this.iframeUrl ? (React.createElement(iframe_preview_1.IFramePreview, { title: this.currentAssetViewing.fileOriginalName || "N/A", iframeUrl: this.iframeUrl, download: this.iframeUrl, onClose: this.handlePreviewClose })) : null,
            React.createElement(ReactTooltip, { effect: "solid", place: "left", delayShow: 300, "data-type": "info", multiline: true }),
            React.createElement(ReactTooltip, { effect: "solid", place: "left", delayShow: 300, "data-type": "error", multiline: true, id: "valid-provider" })));
    }
    onChangeMultiSelect(values) {
        this.provider.sites = store_4.sitesListStore.sites.value
            ? store_4.sitesListStore.sites.value.filter(site => values.map(value => value.value).indexOf(String(site.id)) >= 0)
            : [];
        if (this.missing.sites) {
            if (this.provider.sites && this.provider.sites.length) {
                this.missing.sites = false;
            }
        }
    }
    onChangeMultiSelectInChargeOf(values) {
        this.sitesInChargeOf = store_4.sitesListStore.sites.value
            ? store_4.sitesListStore.sites.value.filter(site => values.map(value => value.value).indexOf(String(site.id)) >= 0)
            : [];
        if (!this.inChargeOfChanged) {
            this.inChargeOfChanged = true;
        }
    }
};
__decorate([
    mobx_1.computed
], EditProvider.prototype, "availableUsers", null);
__decorate([
    mobx_1.computed
], EditProvider.prototype, "availableOptions", null);
__decorate([
    mobx_1.computed
], EditProvider.prototype, "availableOptionsInCharge", null);
__decorate([
    mobx_1.observable
], EditProvider.prototype, "provider", void 0);
__decorate([
    mobx_1.observable
], EditProvider.prototype, "sitesInChargeOf", void 0);
__decorate([
    mobx_1.observable
], EditProvider.prototype, "iframeUrl", void 0);
__decorate([
    mobx_1.observable
], EditProvider.prototype, "currentAssetViewing", void 0);
__decorate([
    mobx_1.observable
], EditProvider.prototype, "padsOpen", void 0);
__decorate([
    mobx_1.observable
], EditProvider.prototype, "pads", void 0);
__decorate([
    mobx_1.observable
], EditProvider.prototype, "assetModal", void 0);
__decorate([
    mobx_1.observable
], EditProvider.prototype, "providerSitesAbsent", void 0);
__decorate([
    mobx_1.observable
], EditProvider.prototype, "sitesAbsentChanged", void 0);
__decorate([
    mobx_1.observable
], EditProvider.prototype, "inChargeOfChanged", void 0);
__decorate([
    mobx_1.observable
], EditProvider.prototype, "titlesStr", void 0);
__decorate([
    mobx_1.observable
], EditProvider.prototype, "titles", void 0);
__decorate([
    mobx_1.observable
], EditProvider.prototype, "highLevelTitles", void 0);
__decorate([
    mobx_1.observable
], EditProvider.prototype, "missing", void 0);
__decorate([
    mobx_1.observable
], EditProvider.prototype, "showConfirmationEditProviderSave", void 0);
EditProvider = __decorate([
    mobx_react_1.observer
], EditProvider);
exports.EditProvider = EditProvider;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/providers/modules/providers-list/components/edit-provider/edit-provider.tsx
// module id = 3780
// module chunks = 0